import { usePaymentStore } from "stores/paymentStore"

export function PayLaterAlert() {
  const { payLater } = usePaymentStore()
  if ( !payLater ) return null

  return (
    <div className="px-10 py-5 bg-[#FFC31F] flex gap-4 items-start my-5">
      <div className="bg-white rounded-full w-[24px] h-[24px] flex items-center justify-center mt-2">
        <p className="text-[#FFC31F] text-lg px-3">{`!`}</p>
      </div>
      <p className="text-black font-semibold">
        {`You owe a balance on this order - you will receive email and mail notifications to pay your bill later.`}
      </p>
    </div>
  )
}